import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FaArrowDown } from 'react-icons/fa6';
import calendarPageImage from '../assets/images/calendar_page_full.webp';
import homePageImage from '../assets/images/home_page_full.webp';
import timeListPageImage from '../assets/images/time_list_page_full.webp';
const STEPS = [
    {
        step: 1,
        title: 'フォルダを作成',
        description: '記録したいことをフォルダーとして追加します。',
        subText: '例：吐き戻し、頭痛、フィルター掃除など',
        image: homePageImage,
        alt: 'Histotime ホーム画面'
    },
    {
        step: 2,
        title: 'タップで記録',
        description: '起きたらタップするだけ。日時が自動で記録されます。',
        subText: '手入力なし、ワンタップで完了',
        image: timeListPageImage,
        alt: 'Histotime 記録画面'
    },
    {
        step: 3,
        title: 'カレンダーで振り返り',
        description: 'いつ、どのくらいの頻度で起きているか一目で確認。',
        subText: '傾向が見えると、次の行動に活かせる',
        image: calendarPageImage,
        alt: 'Histotime カレンダー画面'
    }
];
const StepItem = ({ isLast, isReversed, step })=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: `flex w-full flex-col items-center gap-8 lg:flex-row lg:gap-16 ${isReversed ? 'lg:flex-row-reverse' : ''}`,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-1 justify-center",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "w-64 transition-transform duration-300 hover:scale-105 md:w-72",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: step.image,
                                alt: step.alt,
                                className: "h-auto w-full"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: `flex-1 ${isReversed ? 'lg:text-right' : 'lg:text-left'} text-center`,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: `mb-4 inline-flex items-center gap-3 ${isReversed ? 'lg:flex-row-reverse' : ''}`,
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "flex h-12 w-12 items-center justify-center rounded-full bg-teal-600 text-xl font-bold text-white",
                                        children: step.step
                                    }),
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "text-sm font-semibold tracking-wider text-teal-600 uppercase",
                                        children: [
                                            "STEP ",
                                            step.step
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "mb-4 text-2xl font-bold text-gray-900 md:text-3xl",
                                children: step.title
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mb-2 text-lg text-gray-700",
                                children: step.description
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm text-gray-500",
                                children: step.subText
                            })
                        ]
                    })
                ]
            }),
            !isLast && /*#__PURE__*/ _jsx("div", {
                className: "my-12 flex justify-center",
                children: /*#__PURE__*/ _jsx(FaArrowDown, {
                    className: "text-3xl text-teal-300"
                })
            })
        ]
    });
};
const Features = ()=>{
    return /*#__PURE__*/ _jsx("section", {
        className: "bg-white px-4 py-24 md:px-8",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto max-w-5xl",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "mb-16 text-center",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "mb-4 text-3xl font-bold text-gray-900 md:text-4xl",
                            children: "かんたん3ステップ"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-gray-500",
                            children: "シンプルだから、続けられる"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mb-16",
                    children: STEPS.map((step, index)=>/*#__PURE__*/ _jsx(StepItem, {
                            step: step,
                            isReversed: index % 2 === 1,
                            isLast: index === STEPS.length - 1
                        }, step.step))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "rounded-2xl bg-gray-50 p-8 text-center",
                    children: /*#__PURE__*/ _jsxs("p", {
                        className: "text-lg text-gray-700 md:text-xl",
                        children: [
                            "入力は最小限。",
                            /*#__PURE__*/ _jsx("br", {
                                className: "sm:hidden"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "hidden sm:inline",
                                children: " "
                            }),
                            "「",
                            /*#__PURE__*/ _jsx("span", {
                                className: "font-bold",
                                children: "続ける"
                            }),
                            "」より、「",
                            /*#__PURE__*/ _jsx("span", {
                                className: "font-bold",
                                children: "残す"
                            }),
                            "」ことを大切にしています。"
                        ]
                    })
                })
            ]
        })
    });
};
export default Features;
